import { UnitConstants } from 'src/app/core/constants/unit';
import { ValidatorsTerms } from 'src/app/shared/validators/validators-terms';

const TERMS = ValidatorsTerms;

export class RigidTubeUtilizationFactorFields {
  public static controls = {
    safetyClassType: {
      quantity: null,
      validator: TERMS.REQUIRED,
    },
    initialSectionOvalization: {
      quantity: null,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
    materialStrengthFactor: {
      quantity: null,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO_MAX_ONE,
    },
    yieldStress: {
      quantity: UnitConstants.QUANTITY.ELASTIC_MODULE,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
    ultimateStress: {
      quantity: UnitConstants.QUANTITY.ELASTIC_MODULE,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
    fabricationFactor: {
      quantity: null,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO_MAX_ONE,
    },
    conditionalLoadFactor: {
      quantity: null,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO_MAX_ONE,
    },
    craThickness: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
    craSteelYieldStress: {
      quantity: UnitConstants.QUANTITY.ELASTIC_MODULE,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
    craUltimateStress: {
      quantity: UnitConstants.QUANTITY.ELASTIC_MODULE,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
  };
}
